import { useQuery } from 'convex/react';
import { api } from '../../convex/_generated/api';
import type { Id } from '../../convex/_generated/dataModel';
import { PLANS, type PlanId } from '../utils/billing/plans';

/**
 * Hook for getting family plan entitlements.
 * Uses Convex reactive query — automatically updates when plan changes
 * (e.g., after Stripe webhook). No polling needed.
 */
export function useEntitlements(familyId?: string) {
  const planData = useQuery(
    api.billing.queries.getFamilyPlan,
    familyId ? { familyId: familyId as Id<"families"> } : "skip"
  );

  const planId: PlanId = (planData?.planId as PlanId) || 'basic';

  return { ...PLANS[planId], planId };
}
